import { Box, Button, Modal, TextField, Typography } from '@mui/material'
import React from 'react'
import { modalStyle } from 'src/utils/history'
//import { COLORS } from './Colors'



const DownloadModal = ({
  showPopup,
  setShowPopup,
  diagramName,
  setDiagramName,
  handleDownloadCnst,
}) => {

  const downloadStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    borderRadius: 3,
    minWidth:'350px',
    minHeight:'200px'
  }
  return (
    <Modal open={showPopup} onClose={() => setShowPopup(false)}>
      <Box sx={downloadStyle}>
        <Typography id="modal-modal-title" variant="h5" component="h2">
          Download Diagram
        </Typography>
       
        <TextField
          size="small"
          autoFocus='true'
          margin='normal'
          fullWidth
          hiddenLabel
          id="filled-hidden-label-small"
          label="Enter diagram name to download as:"
          variant="standard" 
          autoComplete="off"
          value={diagramName}
          onChange={(e) => setDiagramName(e.target.value)}
        />

        <Typography id="modal-modal-title" variant="body2">
         Please enter atleast 4 characters
        </Typography>

        <footer style={{ display: 'flex', gap: '20px', justifyContent: 'flex-end', marginTop: '40px',padding:'0px', marginRight: '10px', marginBottom:'0px'}}>
          <Button  className="cancel-button-dwnld" onClick={() => setShowPopup(false)}>
            Cancel
          </Button>
          <Button
            
            className="icon-button"
            onClick={() => {
              handleDownloadCnst()
              
            }}
          >
            Download
          </Button>
        </footer>
      </Box>
    </Modal>
  )
}

export default DownloadModal
